import { render, staticRenderFns } from "./AdvertCampaignTableItem.vue?vue&type=template&id=058cf88a&scoped=true&"
import script from "./AdvertCampaignTableItem.vue?vue&type=script&lang=ts&"
export * from "./AdvertCampaignTableItem.vue?vue&type=script&lang=ts&"
import style0 from "./AdvertCampaignTableItem.vue?vue&type=style&index=0&id=058cf88a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058cf88a",
  null
  
)

export default component.exports